import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";

import "../../css/event210621.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
import axios from "axios";

class Locker extends PureComponent {
  state = {};
  componentDidMount = () => {
    const { contentSerial } = this.props.childProps;

    console.log(contentSerial);
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const content = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        content: content,
      });
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + "/event_202210_locker", {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onCloseX = () => {
    const { onCloseX } = this.props.childProps;
    onCloseX();
  };
  render = () => {
    // const { content } = this.state;
    const { flag } = this.props.childProps;
    return (
      <Fragment>
        <div style={{ width: 250, height: 120, textAlign: "center" }}>
          <div
            style={{
              color: "#fff",
              fontSize: 16,
              fontWeight: 700,
              paddingTop: 10,
            }}
          >
            {flag === "S" ? "정답! 보관을 완료했어요." : "구작 보관 중!"}
          </div>
          <div
            style={{
              color: "#ff5d24",
              fontSize: 12,
              fontWeight: 700,
              paddingTop: 10,
            }}
          >
            {flag === "S"
              ? "* 자, 계속 퀴즈를 풀어보아요!"
              : "* 다음 퀴즈를 풀며 빈 보관함을 찾아보아요"}
          </div>
          <div style={{ width: 250, paddingTop: 20 }}>
            <div
              style={{
                backgroundColor: "#fff",
                width: 50,
                height: 25,
                borderRadius: 3,
                textAlign: "center",
                margin: "auto",
              }}
            >
              <div
                style={{
                  color: "#000",
                  fontSize: 14,
                  fontWeight: 700,
                  paddingTop: 3,
                  cursor: "pointer",
                }}
                onClick={this._onCloseX}
              >
                확인
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
}

export default shopContext(withRouter(Locker));
